const s = {
  name: "CheckoutPayByLink",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M21,4V0h-2v4H21z"/>
		<path class="st0" d="M21,7v4h-2V7H21z"/>
		<path class="st0" d="M5,22c0.6,0,1-0.4,1-1s-0.4-1-1-1c-0.6,0-1,0.4-1,1S4.4,22,5,22z"/>
		<path class="st0" d="M9,21c0,0.6-0.4,1-1,1c-0.6,0-1-0.4-1-1s0.4-1,1-1C8.6,20,9,20.4,9,21z"/>
		<path class="st0" d="M11,22c0.6,0,1-0.4,1-1s-0.4-1-1-1c-0.6,0-1,0.4-1,1S10.4,22,11,22z"/>
		<path class="st0" d="M24.7,29.7L19,35.4l-3.7-3.7l1.4-1.4l2.3,2.3l4.3-4.3L24.7,29.7z"/>
		<path class="st0" d="M21,16v-3h-2v3H3c-1.7,0-3,1.3-3,3v18c0,1.7,1.3,3,3,3h34c1.7,0,3-1.3,3-3V19c0-1.7-1.3-3-3-3H21z M3,18h34
			c0.6,0,1,0.4,1,1v5H2v-5C2,18.4,2.4,18,3,18z M38,26v11c0,0.6-0.4,1-1,1H3c-0.6,0-1-0.4-1-1V26H38z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as CheckoutPayByLink
};
